module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.addShow = true
      }
    }
  }, [_vm._v("新增裁判员")])], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户名",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.name) + "\n            "), (scope.row.cert_status == 1) ? _c('el-tag', {
          attrs: {
            "round": "",
            "size": "small",
            "type": "success",
            "effect": "dark"
          }
        }, [_vm._v("已认证")]) : (scope.row.cert_status == 3) ? _c('el-tag', {
          attrs: {
            "round": "",
            "size": "small",
            "effect": "dark"
          }
        }, [_vm._v("认证失败")]) : (scope.row.cardtype == 1 && scope.row.cert_status == 2) ? _c('el-tag', {
          attrs: {
            "round": "",
            "size": "small",
            "type": "warning",
            "effect": "dark"
          }
        }, [_vm._v("未认证")]) : (scope.row.cardtype != 1 && scope.row.cert_status == 2) ? _c('el-tag', {
          attrs: {
            "round": "",
            "size": "small",
            "plain": ""
          }
        }, [_vm._v("无需认证")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "身份证号",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.cert_status == 2) ? _c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleCert(scope.$index, scope.row)
            }
          }
        }, [_vm._v("认证")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.row.currentpage,
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-content",
    attrs: {
      "title": "新增裁判员",
      "visible": _vm.addShow
    },
    on: {
      "update:visible": function($event) {
        _vm.addShow = $event
      },
      "close": function($event) {
        _vm.addShow = false
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件类型",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.cardtype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cardtype", $$v)
      },
      expression: "formData.cardtype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("身份证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("护照")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("其他身份证明")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.formData.cardtype == 1) ? _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "num"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.formData.cardtype != 1) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号码",
      "prop": "huzhao"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.formData.huzhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "huzhao", $$v)
      },
      expression: "formData.huzhao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "QQ",
      "prop": "qq"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入QQ"
    },
    model: {
      value: (_vm.formData.qq),
      callback: function($$v) {
        _vm.$set(_vm.formData, "qq", $$v)
      },
      expression: "formData.qq"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信号",
      "prop": "weixin"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入微信号"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n            ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b287794","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/member/CaipanList.vue
// module id = 1520
// module chunks = 0